import { Entity } from './entity.js'
import { showInfoPanel } from '../ui.js';

export class Satellite extends Entity {
    constructor(
      size,
      texture,
      orbitRadius,
      axialTilt,
      orbitInclin,
      speedTrans,
      speedRot,
      eccentricity,
      argPeriapsis,
      longAscNode,
      label,
      centerElement
    ) {
      let orbitInclinSum = orbitInclin 
      let rotInclinSum = axialTilt + centerElement.axialTilt

      super(centerElement, size, texture, orbitRadius, rotInclinSum, orbitInclinSum, speedTrans, speedRot, eccentricity,argPeriapsis,longAscNode, label);

      this.isMoon = true
      this.mesh.castShadow = true;
      this.mesh.receiveShadow = true;
      this.mesh.renderOrder =2
      this.mesh.material.needsUpdate  = true;

      const type = "_(moon)"

      this.infoIcon.addEventListener('click', (evt) => {
        evt.stopPropagation();
        showInfoPanel(this.name + type);
      });
    }

  }